export enum SortOptionEnum {
    ASC = 'asc',
    DESC = 'dsc'
}
